var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOthers1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:none;stroke:#b53729;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85,
    cy: 85,
    r: 85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.13,102.69a19.76,19.76,0,0,1-6.65-38.36,29,29,0,0,1,56.25-5.07h.35a21.48,21.48,0,0,1,21.34,19.33A12.62,12.62,0,0,1,136.58,90c0,5.64-3.7,11-8.79,12.68h-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.94,67.47v-.16A18.27,18.27,0,0,1,79.2,49.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.11,81.93a9,9,0,0,1,8-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.07,104.53V96.37l-7.26-.61A22.2,22.2,0,0,0,112,88.34l4.85-5.73L111,76.84l-5.56,4.7a22,22,0,0,0-7.27-3.21l-.62-7.49H89.4l-.6,7.26A22.22,22.22,0,0,0,81.38,81l-5.73-4.85-5.77,5.77,4.7,5.56a22.26,22.26,0,0,0-3.22,7.27l-7.48.62v8.17l7.26.61A22.15,22.15,0,0,0,74,111.53l-4.84,5.73L74.93,123l5.56-4.7a22,22,0,0,0,7.27,3.21l.62,7.48h8.17l.6-7.26a21.91,21.91,0,0,0,7.42-2.86l5.73,4.85,5.78-5.77-4.71-5.56a22.35,22.35,0,0,0,3.22-7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.2,99.94A11.23,11.23,0,1,1,93,88.71,11.22,11.22,0,0,1,104.2,99.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers1);
export default __webpack_public_path__ + "static/media/others-1.975bfcf98bba2123aea1d1b4a84c99c6.svg";
export { ForwardRef as ReactComponent };